export const theme = {
  colors: {
    primary: "#1e90ff",
    secondary: "#0f172a",
    accent: "#70a1ff",
    appSecondary: "#009EF7",
    appTertiary: "#64bfff",
    background: "#f5f5f5",
    white: "#ffffff",
    text: "#ffffff",
    subtle: "rgba(255, 255, 255, 0.5)",
    subtle_8: "rgba(0, 0, 0, 0.08) ",
    subtle_5: "rgba(0, 0, 0, 0.05) ",
    error: "#ff4d4f",
    success: "#52c41a",
    warning: "#faad14",
    discord: "#5865F2",
  },
  spacing: {
    xs: "0.25rem", // 4px
    sm: "0.5rem", // 8px
    md: "1rem", // 16px
    lg: "1.5rem", // 24px
    xl: "2rem", // 32px
  },
  borderRadius: {
    xs: "0.125rem", // 2px
    sm: "0.25rem", // 4px
    md: "0.5rem", // 8px
    lg: "1rem", // 16px
  },
  fontSizes: {
    xs: "0.75rem", // 12px
    sm: "0.875rem", // 14px
    md: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    xxl: "1.5rem", // 24px
  },
  fonts: {
    primary: "Nunito, sans-serif",
    secondary: "'Montserrat', sans-serif",
  },
  shadows: {
    // xs: "0 1px 2px rgba(0, 0, 0, 0.05)",
    // sm: "0 2px 4px rgba(0, 0, 0, 0.1)",
    // md: "0 3px 6px rgba(0, 0, 0, 0.15)",
    // lg: "0 10px 20px rgba(0, 0, 0, 0.2)",
    primaryShadow:
      "0 0 0 transparent, 0 0 transparent, 0 0 3px rgba(60, 72, 88, 0.15)",
    secondaryShadow: "0px 0px 50px 0px rgba(82, 63, 105, 0.15)",
  },
  transitions: {
    fast: "0.2s ease-in-out",
    normal: "0.3s ease-in-out",
    slow: "0.5s ease-in-out",
  },
};
